import React, { useEffect, useState } from "react";
import { FILE_EXTENSIONS } from "../../utilities/constants";
import {
  fetchContentType,
  getURLExtension,
  isDocumentURL,
} from "../../utilities/imageUtils";

import DOCIcon from "../../assets/images/doc.svg";
import PDFIcon from "../../assets/images/pdf.svg";
import FileIcon from "../../assets/images/file.svg";
import UnidefindeFileIcon from "../../assets/images/undefined-file.svg";

const getIconByExtension = (url) => {
  switch (getURLExtension(url)) {
    case FILE_EXTENSIONS.PDF:
      return PDFIcon;
    case FILE_EXTENSIONS.DOC:
    case FILE_EXTENSIONS.DOCX:
      return DOCIcon;
    default:
      return FileIcon;
  }
};

const getIconByContentType = (contentType) => {
  if (!contentType) return FileIcon;
  if (contentType.includes("pdf")) return PDFIcon;
  if (/msword|wordprocessingml/.test(contentType)) return DOCIcon;
  return FileIcon;
};

// Manzilda kengaytma bo'lmasligi mumkin (/api/v1/files/{id}), shuning uchun
// avval rasm sifatida ko'rsatishga urinamiz. Yuklanmasa — server bergan
// Content-Type bo'yicha mos ikonka (PDF, Word yoki umumiy fayl).
const ImagePlaceHolder = ({ image, imageAlt, imageName = "file" }) => {
  const [hasImageError, setHasImageError] = useState(false);
  const [fallbackIcon, setFallbackIcon] = useState(FileIcon);

  useEffect(() => {
    setHasImageError(false);
    setFallbackIcon(FileIcon);
  }, [image]);

  useEffect(() => {
    if (!hasImageError || !image) return undefined;

    let isActual = true;
    fetchContentType(image).then((contentType) => {
      if (isActual) setFallbackIcon(getIconByContentType(contentType));
    });

    return () => {
      isActual = false;
    };
  }, [hasImageError, image]);

  const isShowingImage = image && !isDocumentURL(image) && !hasImageError;

  const renderSource = () => {
    if (!image) return UnidefindeFileIcon;
    if (isDocumentURL(image)) return getIconByExtension(image);
    if (hasImageError) return fallbackIcon;
    return image;
  };

  return (
    <a
      href={image}
      target="_blank"
      rel="noreferrer"
      className="d-flex flex-column h6"
    >
      <img
        src={renderSource()}
        alt={imageAlt}
        className="rounded"
        width="130px"
        height={isShowingImage ? "130px" : "100%"}
        style={isShowingImage ? { objectFit: "cover" } : undefined}
        onError={() => setHasImageError(true)}
      />
      <span className="mt-2">{imageName}</span>
    </a>
  );
};

export default ImagePlaceHolder;
